import * as z from "zod/v4";
import { conciergeSkillsSchema } from "./common/concierge-skills-schema";

export const updateConciergeSkillsSettings = {
  name: "updateConciergeSkillsSettings" as const,
  input: z.object({ settings: conciergeSkillsSchema }),
  output: z.null(),
};
